import axios from "axios";
import { route } from "./routes";
import { useQuery, useMutation } from "react-query";
import { useState, useEffect } from "react";

import HTTP from "../../axios";

export function useLocationInfo() {
    return useQuery([route.USER_LOCATION_AND_INFO], async () => {
      const { data } = await axios.get(route.USER_LOCATION_AND_INFO);
      return data;
    })
  }


// get user Logs
export function useUserLogs(payload={}){
  return useQuery([route.ALL_lOGS, JSON.stringify(payload)], async () => {
    const { data } = await HTTP.get(route.ALL_lOGS, {
      params:payload
    });
    return data;
  })
}


// delete one or more logs
export function useDeleteLogs(){
  return useMutation(async (ids) => {
    const { data } = await HTTP.post(route.DELETE_LOGS, { ids });
    return data;
  })
}


export function useGetAllUser(){
  return useQuery([route.ALL_USERS], async () => {
    const { data } = await HTTP.get(route.ALL_USERS);
    return data;
  })
}


// Define your custom hook
export const useLocalStorageUser = () => {
  // Initialize state with the user from localStorage or null if not present
  const [user, setUser] = useState(() => {
    try {
      const storedUser = localStorage.getItem('user');
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (error) {
      console.error('Error parsing user from localStorage:', error);
      return null;
    }
  });

  // Function to update user in localStorage and state
  const updateUser = newUser => {
    try {
      localStorage.setItem('user', JSON.stringify(newUser));
      setUser(newUser);
    } catch (error) {
      console.error('Error updating user in localStorage:', error);
    }
  };

  // Effect to sync user state with localStorage
  useEffect(() => {
    try {
      const storedUser = localStorage.getItem('user');
      if (storedUser && storedUser !== user) {
        setUser(JSON.parse(storedUser));
      }
    } catch (error) {
      console.error('Error syncing user state with localStorage:', error);
    }
  }, [user]);

  return { user, updateUser };
};